enum EnumTotemTypeValues {
    Smart = 'Totem SMART',
    Tablet = 'Totem com MINIZINHA',
    Pix = 'Totem PIX',
    Aux = 'Totem modo auxiliar (Tablet + Smart)',
}

const EnumTotemLabel: Record<EnumTotemTypeValues, string> = {
    [EnumTotemTypeValues.Smart]: 'Smart',
    [EnumTotemTypeValues.Tablet]: 'Tablet',
    [EnumTotemTypeValues.Pix]: 'Pix',
    [EnumTotemTypeValues.Aux]: 'Aux',
};

export enum EnumTotemType {
    Smart = 'Smart',
    Tablet = 'Tablet',
    Pix = 'Pix',
    Aux = 'Aux',
}

export const AddressState = [
    { value: 'AC', label: 'AC' },
    { value: 'AL', label: 'AL' },
    { value: 'AP', label: 'AP' },
    { value: 'AM', label: 'AM' },
    { value: 'BA', label: 'BA' },
    { value: 'CE', label: 'CE' },
    { value: 'DF', label: 'DF' },
    { value: 'ES', label: 'ES' },
    { value: 'GO', label: 'GO' },
    { value: 'MA', label: 'MA' },
    { value: 'MS', label: 'MS' },
    { value: 'MT', label: 'MT' },
    { value: 'MG', label: 'MG' },
    { value: 'PA', label: 'PA' },
    { value: 'PB', label: 'PB' },
    { value: 'PR', label: 'PR' },
    { value: 'PE', label: 'PE' },
    { value: 'PI', label: 'PI' },
    { value: 'RJ', label: 'RJ' },
    { value: 'RN', label: 'RN' },
    { value: 'RS', label: 'RS' },
    { value: 'RO', label: 'RO' },
    { value: 'RR', label: 'RR' },
    { value: 'SC', label: 'SC' },
    { value: 'SP', label: 'SP' },
    { value: 'SE', label: 'SE' },
    { value: 'TO', label: 'TO' },
];

export const totemOptions = Object.entries(EnumTotemLabel).map(
    ([label, value]) => ({
        label,
        value,
    }),
);
